import { useEffect, useState, useCallback } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useOcorrencias = ({ sqAcaoFiscal, tipoAutoInfracao, sqAutoInfracao, sqItemOcorrencia }) => {
  const [dadosOcorrencia, setDadosOcorrencia] = useState([]);

  const {
    request: ocorrenciasRequest,
    data: ocorrenciasData,
    errors: ocorrenciasErrors,
    isLoading: ocorrenciasIsLoading,
  } = useApiClient();

  const consultaOcorrencias = useCallback(() => {
    if (tipoAutoInfracao || sqItemOcorrencia > 0) {
      const params = {
        sqAcaoFiscal,
        tipoAutoInfracao,
        sqAutoInfracao,
        sqItemOcorrencia,
      };

      ocorrenciasRequest(apiRoutes.fiscalizacao.autoinfracao.consultaOcorrenciaOs, params);
    }
  }, [ocorrenciasRequest, sqAcaoFiscal, sqAutoInfracao, sqItemOcorrencia, tipoAutoInfracao]);

  useEffect(() => {
    if (ocorrenciasIsLoading) return;

    if (!ocorrenciasData && !ocorrenciasErrors) return;

    if (ocorrenciasData) {
      setDadosOcorrencia(ocorrenciasData.result[0]);
    }
  }, [ocorrenciasData, ocorrenciasIsLoading, ocorrenciasErrors]);

  return { ocorrenciasIsLoading, consultaOcorrencias, ocorrenciasErrors, dadosOcorrencia };
};

export default useOcorrencias;
